import { useEffect, useState } from "react";
import BackBtn from "../../common/backBTN";
import NoData from "../../common/NoData";
import DatePickerPopup from "../../common/DatePickerPopup"; // ✅ popup import

function BettingRecord() {
  const [activeTab, setActiveTab] = useState("settle");
  const [providers, setProviders] = useState([]);
  const [gameTypes, setGameTypes] = useState([]);
  const [bettingRecords, setBettingRecords] = useState([]);
  const [exchangeRecords, setExchangeRecords] = useState([]);
  const [selectedPlatform, setSelectedPlatform] = useState("All");
  const [selectedType, setSelectedType] = useState("All");
  const [selectedDate, setSelectedDate] = useState({ start: "", end: "" });
  const [showPicker, setShowPicker] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [selectedExchangeRecord, setSelectedExchangeRecord] = useState(null);

  // --- helper for actual datetime range filtering
  const isDateInRange = (recordDate, selectedDate) => {
    if (!selectedDate?.start || !selectedDate?.end) return true;
    const record = new Date(recordDate);
    const start = new Date(selectedDate.start);
    const end = new Date(selectedDate.end);
    return record >= start && record <= end;
  };

const formatDisplay = () => {
  if (!selectedDate.start || !selectedDate.end) return "Today";

  const start = new Date(selectedDate.start);
  const end = new Date(selectedDate.end);

  const sameDay = start.toDateString() === end.toDateString();

  const fmtTime = (d) => d.toTimeString().slice(0, 8);
  const fmtDate = (d) =>
    `${String(d.getMonth() + 1).padStart(2, "0")}/${String(
      d.getDate()
    ).padStart(2, "0")}`;

  if (sameDay) {
    return `${fmtDate(start)} ${fmtTime(start)} - ${fmtTime(end)}`;
  }

  return `${fmtDate(start)} ${fmtTime(start)} - ${fmtDate(end)} ${fmtTime(end)}`;
};
// ✅ Set Default Date Range = Today
useEffect(() => {
  const now = new Date();
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);

  setSelectedDate({
    start: startOfToday.toISOString(),
    end: now.toISOString(),
  });
}, []);



  // === fetch data
  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      try {
        const [providersResponse, typesResponse, recordsResponse, exchangeResponse] = await Promise.all([
          fetch(`${process.env.REACT_APP_API_URL}/api/get-provider`, { headers }),
          fetch(`${process.env.REACT_APP_API_URL}/api/get-type`, { headers }),
          fetch(`${process.env.REACT_APP_API_URL}/api/betting-record`, { headers }),
          fetch(`${process.env.REACT_APP_API_URL}/api/exchange-hub`, { headers }),
        ]);

        if (providersResponse.ok && typesResponse.ok) {
          const providersData = await providersResponse.json();
          const typesData = await typesResponse.json();
          setProviders(providersData.data);
          setGameTypes(typesData.types);
        }

        const recordsData = recordsResponse.ok ? await recordsResponse.json() : [];
        setBettingRecords(recordsData || []);

        const exchangeData = exchangeResponse.ok ? await exchangeResponse.json() : { data: [] };
        setExchangeRecords(exchangeData.data || []);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  // === filters ===
  const filteredRecords = bettingRecords.filter((record) => {
    const matchesPlatform =
      selectedPlatform === "All" || record.platform === selectedPlatform;
    const matchesType =
      selectedType === "All" || record.game_type === selectedType;
    const matchesDate = isDateInRange(record.created_at, selectedDate);
    return matchesPlatform && matchesType && matchesDate;
  });

  const filteredExchangeRecords = exchangeRecords.filter((record) => {
    const matchesPlatform =
      selectedPlatform === "All" || record.platform === selectedPlatform;
    const matchesType =
      selectedType === "All" || record.game_type === selectedType;
    const matchesDate = isDateInRange(record.created_at, selectedDate);
    return matchesPlatform && matchesType && matchesDate;
  });

  // === totals ===
  const totalBetAmount = filteredRecords.reduce(
    (sum, record) => sum + (parseFloat(record.bet_amount) || 0),
    0
  );
  const totalWinAmount = filteredRecords.reduce(
    (sum, record) => sum + (parseFloat(record.winAmount) || 0),
    0
  );
  const totalProfitLoss = totalWinAmount - totalBetAmount;

  // === popup confirm
  const handleConfirmDate = (range) => {
    setSelectedDate(range);
    setShowPicker(false);
  };

  return (
    <div id="mc-animate-container" className="v-base v-detail-base fade-enter-done">
      <div className="mc-game-record-root">
        <div className="mc-header-wrap">
          <div
            id="mc-header"
            className="mc-navbar-blue mc-gameRecord mc-default-header am-navbar am-navbar-light"
          >
            <BackBtn />
            <div className="am-navbar-title">Betting Record</div>
            <div className="am-navbar-right">
              <div className="exclude-btn">Exclusion turnover list</div>
            </div>
          </div>
          <div className="am-whitespace am-whitespace-sm mc-whitespace" />
        </div>

        {/* ===== Provider Tabs ===== */}
        <div className="am-tabs am-tabs-top i18n-fix mc-tabs-scroll">
          <div className="mc-tab-container" id="mc-tab-container">
            {providers.map((provider) => (
              <div
                key={provider.platform}
                onClick={() => setSelectedPlatform(provider.platform)}
                className={`${selectedPlatform === provider.platform ? "tab-active" : ""} mc-tab-item`}
              >
                <span>{provider.platform}</span>
              </div>
            ))}
          </div>

          {/* ===== Filters ===== */}
          <div className="am-tabs-content am-tabs-content-no-animated">
            <div role="tabpanel" aria-hidden="false" className="am-tabs-tabpane am-tabs-tabpane-active">
              <div className="main game-record-wrapper RNG">
                <div className="chooser-mask" />
                <div className="am-flexbox am-flexbox-align-middle mc-trans-filter mc-filter">
                  <div className="am-flexbox am-flexbox-align-middle mc-trans-filter">
                    <div className="flex-shrink1 filter-time-btn">
                      <a
                        role="button"
                        className="am-button am-button-ghost am-button-small am-button-inline am-button-icon"
                        aria-disabled="false"
                        style={{ flex: "0 0 50%", cursor: "pointer" }}
                        onClick={() => setShowPicker(true)}
                      >
                        <svg
                          className="am-icon am-icon-calendar_c4db3b67 am-icon-xxs"
                          aria-hidden="true"
                        >
                          <use xlinkHref="#calendar_c4db3b67" />
                        </svg>
                        <span>{formatDisplay()}</span>
                      </a>
                    </div>

                    <a
                      role="button"
                      className="vasslage-btn am-button am-button-ghost am-button-small am-button-inline am-button-icon"
                      aria-disabled="false"
                    >
                      <svg className="am-icon am-icon-down am-icon-xxs" aria-hidden="true">
                        <use xlinkHref="#down" />
                      </svg>
                      <span>All</span>
                    </a>
                  </div>

                  <svg
                    className="am-icon am-icon-search am-icon-lg"
                    style={{ color: "rgb(16, 142, 233)", paddingLeft: "0.2rem" }}
                  >
                    <use xlinkHref="#search" />
                  </svg>
                </div>

                {/* ===== Betting Records ===== */}
                <div>
                  <div className="padding-bottom-2rem" style={{ overflow: "hidden" }}>
                    <div className="list-wrapper">
                      <ul className="scroll-inner-container">
                        {filteredRecords.length === 0 ? (
                          <NoData />
                        ) : (
                          filteredRecords.map((record, index) => (
                            <li key={index}>
                              <div className="lott-records-root">
                                <div className="records-item-header-sy">
                                  <div className="am-flexbox am-flexbox-dir-row am-flexbox-justify-between am-flexbox-align-middle">
                                    <div className="am-flexbox am-flexbox-dir-row am-flexbox-align-middle">
                                      <i
                                        style={{
                                          width: "0.2rem",
                                          height: "0.2rem",
                                          marginRight: "0.2rem",
                                          display: "inline-block",
                                          borderRadius: "50%",
                                          background: "rgb(16, 142, 233)",
                                        }}
                                      />
                                      <div className="mc_common_overflow" style={{ fontWeight: 600 }}>
                                        {record.game_name}
                                      </div>
                                    </div>
                                    <div className="record_date" style={{ fontSize: "0.26rem" }}>
                                      {new Date(record.created_at)
                                        .toISOString()
                                        .slice(0, 19)
                                        .replace("T", " ")}
                                    </div>
                                  </div>
                                </div>

                                <div className="records-item-content-sy">
                                  <div className="am-flexbox am-flexbox-justify-between am-flexbox-align-middle">
                                    <span>Order no.:</span>
                                    <span className="order-number-group">
                                      {record.platform_tx_id}
                                    </span>
                                  </div>
                                  <div className="am-flexbox am-flexbox-justify-between am-flexbox-align-middle">
                                    <span>Bet amount: {record.bet_amount}</span>
                                    <span>Valid bet: -</span>
                                  </div>
                                  <div className="am-flexbox am-flexbox-dir-row am-flexbox-justify-between am-flexbox-align-middle">
                                    <div className="am-flexbox am-flexbox-dir-column">
                                      <span className="time">Profit & Loss</span>
                                      <span
                                        className={
                                          record.winAmount - record.bet_amount < 0
                                            ? "amount-negative-number record-amount"
                                            : "amount-positive-number record-amount"
                                        }
                                      >
                                        {Math.abs(record.winAmount - record.bet_amount).toFixed(2)}
                                      </span>
                                    </div>
                                    <div className="am-flexbox am-flexbox-dir-column">
                                      <span className="time">Winnings</span>
                                      <span className="amount-positive-number record-amount">
                                        {record.winAmount}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </li>
                          ))
                        )}
                      </ul>
                    </div>
                  </div>
                </div>

                {/* ===== Footer Totals ===== */}
               
<div className="betting-footer-wrap record-footer">
  <div className="am-flexbox am-flexbox-dir-row am-flexbox-justify-between am-flexbox-align-middle total-money">

    {/* Bet amount */}
    <div className="am-flexbox am-flexbox-dir-column am-flexbox-justify-center am-flexbox-align-top total-money-item">
      <span className="time">Bet amount</span>
      <span
        className="loss-amount"
        style={{ fontWeight: 700, fontSize: "0.24rem" }}
      >
        {totalBetAmount.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      </span>
    </div>

    {/* Valid bet */}
    <div className="am-flexbox am-flexbox-dir-column am-flexbox-justify-center am-flexbox-align-top total-money-item">
      <span className="time">Valid bet</span>
      <span
        className="loss-amount"
        style={{ fontWeight: 700, fontSize: "0.24rem" }}
      >
        0.00
      </span>
    </div>

    {/* Winnings */}
    <div className="am-flexbox am-flexbox-dir-column am-flexbox-justify-center am-flexbox-align-top total-money-item">
      <span className="time">Winnings</span>
      <span
        className="loss-amount"
        style={{ fontWeight: 700, fontSize: "0.24rem" }}
      >
        {totalWinAmount.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      </span>
    </div>

    {/* Profit and loss */}
    <div className="am-flexbox am-flexbox-dir-column am-flexbox-justify-center am-flexbox-align-top total-money-item">
      <span className="time">Profit and loss</span>
      <span
        className={totalProfitLoss >= 0 ? "win-amount" : "loss-amount"}
        style={{ fontWeight: 700, fontSize: "0.24rem" }}
      >
        
        {Math.abs(totalProfitLoss).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      </span>
    </div>
  </div>
</div>


               

              </div>
            </div>
          </div>
        </div>

        {/* ✅ Popup Date Picker */}
        <DatePickerPopup
          visible={showPicker}
          onClose={() => setShowPicker(false)}
          onConfirm={handleConfirmDate}
        />
      </div>
    </div>
  );
}

export default BettingRecord;
